import request from '@/utils/http';
const otpBaseUrl = 'api-antms/transport';

// 列表查询
export const getTransferSystemList = (params) => {
    return request({
        url: `api-antms/query/lsp/transfer/pcsearch`,
        method: 'post',
        data: params
    });
};

// 列表查询 数据条数
export const getTransferSystemTotalData = (params) => {
    return request({
        url: `api-antms/query/lsp/transfer/pcsearchCount`,
        method: 'post',
        data: params
    });
};

// 转单确认 或 指派末端司机
export const transferOrderOrAssignDriver = (params) => {
    return request({
        url: `${otpBaseUrl}/lsp/transfer/confirm`,
        method: 'post',
        data: params
    });
};

// 撤回
export const recallTransferSystem = (params) => {
    return request({
        url: `${otpBaseUrl}/lsp/transfer/recall`,
        method: 'post',
        data: params
    });
};

//配置日志 查询操作记录
export const getLogDataList = (params) => {
    return request({
        // url: `${otpBaseUrl}/lsp/transfer/checklogPage`,
        url: `api-antms/query/lsp/transfer/getOperationLog`,
        method: 'post',
        data: params
    });
};

//配置日志 查询操作记录数据条数
export const getLogTotalData = (params) => {
    return request({
        // url: `${otpBaseUrl}/lsp/transfer/checklogPageCount`,
        url: `api-antms/query/lsp/transfer/getOperationLogCount`,
        method: 'post',
        data: params
    });
};

// 查询 当前登录人的MIP账号 是供应商还是货站
export const getLoginAccount = (params) => {
    return request({
        url: `${otpBaseUrl}/lsp/transfer/getLoginAccount`,
        method: 'post',
        data: params
    });
};

// 查询 货站高级搜索弹窗数据
export const getStationSearchList = (params) => {
    return request({
        url: `${otpBaseUrl}/lsp/transfer/getStationList`,
        method: 'post',
        data: params
    });
};

// 物流快递转派记录查询
export const logisticsExpressQuery = (params) => {
    return request({
        url: `${otpBaseUrl}/lsp/transfer/logisticsExpressQuery?customerOrderNo=${params}`,
        method: 'get'
    });
};

// 转快递保存
export const expressSave = (params) => {
    return request({
        url: `${otpBaseUrl}/lsp/transfer/expressSave`,
        method: 'post',
        data: params
    });
};

// 批量转快递导入确认
export const expressImportConfirm = (params) => {
    return request({
        url: `${otpBaseUrl}/lsp/transfer/expressImportConfirm`,
        method: 'post',
        data: params
    });
};

// 转快递查看路由
export const viewRouteApi = (params, data) => {
    return request({
        url: `${otpBaseUrl}/lsp/transfer/queryRoute?customerOrderNo=${params}&taskNo=${data}`,
        method: 'get'
    });
};

// 货站运抵弹窗信息接口
export const queryStationArriveInfoByDispatchNo = (data) => {
    return request({
        url: `api-antms/query/lsp/transferCenter/queryStationArriveInfoByDispatchNo`,
        method: 'post',
        data
    });
};

// 货站运抵弹窗货站明细查询接口
export const queryStationArriveDetailByParam = (data) => {
    return request({
        url: `/api-antms/query/lsp/transferCenter/queryStationArriveDetailByParam`,
        method: 'post',
        data
    });
};

// 货站运抵弹窗 运抵确认接口
export const updateStationArrivedForPC = (data) => {
    return request({
        url: `/api-antms/transport/transport/updateStationArrivedForPC`,
        method: 'post',
        data
    });
};


